export default {"src":"/_next/static/media/mastering.004f82b9.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};